import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: #fff;
  height: 70px;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem calc((100vw - 1000px) / 3);
  z-index: 10;
  position: fixed;
  width: 100%;
  font-family: Poppins;
  transition: box-shadow 0.3s ease-in-out;

  ${(props) =>
    props.isScrolled &&
    `
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  `};
`;

export const NavLink = styled(Link)`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 500;

  &.active {
    color: #0a939c;
    border-bottom: 2px solid #0a939c;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #0a939c;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  background: #256ce1;
  padding: 5px 12px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #0a939c;
    border: 1px solid #0a939c;
  }
`;
